export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=4001dd99e020db414b1bca2bc5755a60c9cea028ef&name=addToFolderEventAction!'